export enum LicenseAction {
  Deactivate,
  Activate,
}

export interface Account {
  accountId: string;
  accountReference: string;
  name: string;
  admin: string;
  accountInformation: AccountInformation[];
}

export interface AccountInformation {
  key: string;
  value: string;
}

export interface Service {
  serviceReference: string;
  name: string;
  serviceClaims: ServiceClaim[];
}

export interface ServiceClaim {
  friendlyName: string;
  shortName: string;
  claimType: string;
  claimValue: string;
  displaySingleServiceClaimOptionDescription: boolean;
  options: ServiceClaimOption[];
}

export interface ServiceClaimOption {
  claimValue: string;
  claimValueDescription: string;
}

export interface ServiceSummary extends Service {
  serviceGroup: string;
  description: string;
  licenseReference: string;
  licenseQualifier: string;
  seatsUsed: number;
  seatsTotal: number;
  nextLicenseExpiresOn?: string;
  activeSeats: Seat[];
  unlimitedSeats: boolean;
  oneTimeSeats: boolean;
  unregisteredUsersCount: number;
  displayDropdownForMultipleOptions: boolean;
}

export interface Seat {
  licenseReference: string;
  name?: string;
  email?: string;
  startDate: string;
  endDate: string;
}

export interface ServiceSeats {
  licenseReference: string;
  service: string;
  used: number;
  total: number;
  unlimited: boolean;
}

export interface User {
  id: string;
  name: string;
  email: string;
  displayEmail: string;
  accountStatus: string;
  lastLogin?: string;
  isAdmin: boolean;
  services: ServiceWithClaims[];
}

export interface Candidate {
  email: string;
  name: string;
  magicloudUser: boolean;
  services: ServiceWithClaims[];
}

export interface UsersResponse {
  availableServices: Service[];
  users: User[];
}

export interface RemoveUsersRequest {
  userIds: string[];
  unregisteredUsers: string[];
}

export interface AdminAccessRequest {
  users: string[];
  adminAccess: boolean;
}

export interface UpdateUserRequest {
  id: string;
  email: string;
  admin: boolean;
  serviceClaims: ServiceWithClaims[];
}

export interface UserWithClaims {
  user: User;
  claims: Claim[];
}

export interface AddClaimsForUsersRequest {
  users: UserIdEmailPair[];
  serviceClaims: ServiceWithClaims[];
}

export interface UserIdEmailPair {
  userId: string;
  email: string;
}

export interface ServiceWithClaims {
  licenseReference: string;
  serviceReference: string;
  claims: Claim[];
}

export interface Claim {
  type: string;
  value: string[];
}

export interface AppTab {
  title: string;
  path: string;
}

export type SortOrder = "asc" | "desc";

export interface UserFilters {
  search: string;
}

export interface SortableColumns {
  name: string;
  email: string;
}

export interface TableHeaderColumn {
  id: string;
  label: string;
  sortable: boolean;
}

export const userTableHeaderColumns: readonly TableHeaderColumn[] = [
  {
    id: "name",
    label: "Name",
    sortable: true,
  },
  {
    id: "email",
    label: "Email",
    sortable: true,
  },
  {
    id: "accountStatus",
    label: "Account status",
    sortable: true,
  },
  {
    id: "lastLogin",
    label: "Last logged in",
    sortable: true,
  },
];

export const roleTableHeaderColumns: readonly TableHeaderColumn[] = [
  {
    id: "name",
    label: "Name",
    sortable: true,
  },
  {
    id: "email",
    label: "Email",
    sortable: true,
  },
  {
    id: "expiryDate",
    label: "Expiry date",
    sortable: true,
  },
];
